import { useNavigate } from 'react-router-dom'
import { HomeIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
export function BreadcrumbsNew({ pages }) {
    const navigate = useNavigate();
    const GotoPage = (pageName) => {
        if(pageName !== "" && pageName !== "#" && pageName !== "/") {
		    navigate(`${pageName}`);
        }
	};
    return (
        <nav aria-label="Breadcrumb" className="flex mb-4 mt-2">
            <ol role="list" className="flex items-center space-x-4">
                <li>
                <div>
                    <a onClick={() => GotoPage("/dashboard")} className="text-gray-400 hover:text-gray-500">
                    <HomeIcon aria-hidden="true" className="size-5 shrink-0 cursor-pointer" />
                    <span className="sr-only">Home</span>
                    </a>
                </div>
                </li>
                {pages.map((page) => (
                <li key={page.name}>
                    <div className="flex items-center">
                    <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                    <a onClick={() => GotoPage(page.href)} aria-current={page.current ? 'page' : undefined} className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer">
                        {page.name}
                    </a>
                    </div>
                </li>
                ))}
            </ol>
        </nav>
    )
}
export function Breadcrumbs({ pages }) {
    const navigate = useNavigate();
    const GotoPage = (pageName) => {
        if(pageName !== "" && pageName !== "#" && pageName !== "/") {
		    navigate(`${pageName}`);
        }
	};
    return (
        <nav aria-label="Breadcrumb" className="flex border-b border-gray-200 bg-white mb-4">
            <ol role="list" className="mx-auto flex w-full max-w-(--breakpoint-xl) space-x-4">
                <li className="flex">
                <div className="flex items-center">
                    <a onClick={() => GotoPage("/dashboard")} className="text-gray-400 hover:text-gray-500">
                    <HomeIcon aria-hidden="true" className="size-5 shrink-0 cursor-pointer" />
                    <span className="sr-only">Home</span>
                    </a>
                </div>
                </li>
                {pages.map((page) => (
                <li key={page.name} className="flex">
                    <div className="flex items-center">
                    <svg
                        fill="currentColor"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                        className="h-full w-6 shrink-0 text-gray-200"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <a onClick={() => GotoPage(page.href)} aria-current={page.current ? 'page' : undefined} className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer">
                        {page.name}
                    </a>
                    </div>
                </li>
                ))}
            </ol>
        </nav>
    )
}